/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

export const sendToHubSpot = async (
	data: Record<string, any>,
	listId: number,
) => {
	try {
		const baseUrl =
			process.env.NODE_ENV === 'production'
				? 'https://yaap.co.za/.netlify/functions'
				: '/.netlify/functions';

		console.log('Sending data to HubSpot:', JSON.stringify(data, null, 2));
		console.log('List ID:', listId);

		const response = await axios.post(`${baseUrl}/send-to-hubspot`, {
			listId,
			...data,
		});
		return response.data;
	} catch (error) {
		console.error('Error sending data to HubSpot:', error);
		if (axios.isAxiosError(error) && error.response) {
			console.error('Response data:', error.response.data);
			console.error('Response status:', error.response.status);
		}
		throw error;
	}
};
